import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'
import { rangePicker } from './range-picker'

window.Alpine = Alpine

Alpine.plugin(mask)
Alpine.data('rangePicker', rangePicker)

Alpine.start()
